(function() {
    'use strict';

    angular
        .module('app.centrosCosto')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/centros-costo',
                config: {
                    templateUrl: 'app/centrosCosto/centrosCosto.html',
                    controller: 'CentrosCosto',
                    controllerAs: 'vm',
                    title: 'CentrosCosto'
                }
            },
            {
                url: '/editar-centro-costo/:id?',
                config: {
                    templateUrl: 'app/centrosCosto/editarCentroCosto.html',
                    controller: 'EditarCentroCosto',
                    controllerAs: 'vm',
                    title: 'EditarCentroCosto'
                }
            }
        ];
    }
})();
